import { render, staticRenderFns } from "./ReportsMetricas.vue?vue&type=template&id=0bfb96ef&"
import script from "./ReportsMetricas.vue?vue&type=script&lang=js&"
export * from "./ReportsMetricas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports